import { EDruhDluhopisu } from 'enums/isin/udaje/druhDluhopisu';

const druhDluhopisCfiSelect = [
    {
        value: EDruhDluhopisu.DL,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_DL'
    },
    {
        value: EDruhDluhopisu.VD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_VD'
    },
    {
        value: EDruhDluhopisu.DS,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_DS'
    },
    {
        value: EDruhDluhopisu.NP,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_NP'
    },
    {
        value: EDruhDluhopisu.HZL,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_HZL'
    },
    {
        value: EDruhDluhopisu.CP,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_CP'
    },
    {
        value: EDruhDluhopisu.KD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_KD'
    },
    {
        value: EDruhDluhopisu.OD,
        labelcz: 'ISIN_EMISE_DLUHOPIS_TYP_OD'
    }
];

export default druhDluhopisCfiSelect;
